import * as go from 'gojs';
import { calculateAttentionNodeLocation, findAttachedAttentionNodes } from './attention-utils';

export const attentionOverrideLayout = (diagram: go.Diagram, category: string) => {
  const layout = diagram.layout;
  overrideLayout(category, layout);
};

const overrideLayout = (attentionCategory: string, layout: go.Layout) => {
  const doLayoutBase = layout.doLayout.bind(layout);
  layout.doLayout = (coll: go.Diagram | go.Group | go.Iterable<go.Part>) => {
    doLayoutBase.call(layout, coll);

    if (!layout?.diagram || !(coll instanceof go.Diagram)) {
      return;
    }

    const attachedAttentionNodes = findAttachedAttentionNodes(layout.diagram.nodes, attentionCategory);

    coll.nodes
      .filter((node) => !!node.key && node.key in attachedAttentionNodes)
      .each((node) => {
        const attentionNode = attachedAttentionNodes[node.key!];
        const position = calculateAttentionNodeLocation(node);
        attentionNode.move(position, true);
      });
  };
};
